import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { connect } from 'react-redux';
import { Paginate } from 'components/elements/Paginate';
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { CardList } from 'components/elements/CardList';
import CampaignsStyle from 'components/admin/Campaigns.module.scss';
import { Helmet } from 'react-helmet';
import classnames from 'classnames';
import { PartnerAdminActions } from 'state/actions/user/PartnerAdminActions';
/**
 * Junta `CardList` com `Paginate` em um novo componente. :)
 *
 * @param {{
 *   history: any,
 *   location: any,
 *   match: any,
 *   staticContext: any,
 * }} props
 */
const CampaignsContainer = ({
  history,
  location,
  match,
  staticContext,
  person,
  token,
  isAdmin,
}) => {
  // State
  // --------------------------------------------------------------------
  const [data, setData] = useState([]);
  const [failure, setFailure] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(9);
  const [totalItems, setTotalItems] = useState(0);
  // Aqui usamos 0, preencha no request de inicialização depois

  // Métodos
  // --------------------------------------------------------------------

  /**
   * Solicita dados da página.
   *
   * @param {number} page
   */
  const fetchDataFromApi = useCallback(
    async page => {
      let endpoint = GlamboxEndpoints.Campaign.get.url;

      fetch(
        `${process.env.REACT_APP_GB_API_ROOT}${endpoint}?page=${
          page - 1
        }&pageSize=${perPage}`,
        {
          method: 'GET',
          headers: new Headers({
            Authorization: token,
          }),
        }
      )
        .then(response => {
          return response.json();
        })
        .then(json => {
          const newData = [];

          json.result.campaigns.forEach(item => {
            newData.push({
              urlImg: item.urlImg,
              title: item.title,
              description: item.description,
              campaignId: item.campaignId,
            });
          });

          setData(newData);
          history.push(`/admin/campaigns/${page}`);
          setPage(page);
          setFailure(false);
          setTotalItems(json.result.totalOfItems);
        })
        .catch(_ => {
          setData([]);
          setFailure(true);
          setTotalItems(0);
        });
    },
    [history, perPage, token]
  );

  const clickEvent = item => {
    const url = `/admin/campaign/${item.campaignId}`;
    history.push(url);
    console.groupCollapsed(`Você clicou no item: "${item.title}"`);
    console.table(item);
    console.groupEnd();
  };

  const gotoCreatePage = e => {
    e.preventDefault();
    history.push('/admin/campaign/create');
  };

  // Lifecycle
  // --------------------------------------------------------------------

  // Funciona como `componentDidMount`, executando apenas na inicialização
  // Para que funcione assim, o segundo parametro de useEffect precisa estar vazio
  useEffect(() => {
    if (typeof person !== 'undefined') {
      isAdmin(person.person.username, response => {
        const isAdmin = response.result;
        if (!isAdmin) {
          history.push('/');
        } else {
          fetchDataFromApi(page);
        }
      });
    }
  }, [fetchDataFromApi, history, isAdmin, page, person]);

  if (!person || !token) return null;
  return (
    <div className={'p-2 p-lg-5'}>
      <Helmet>
        <title>Admin Campanha : Campanhas</title>
      </Helmet>
      <h1>Campanhas</h1>
      <div className={'pb-2'}>
        <button
          className={'btn btn-light-pink btn-md'}
          onClick={gotoCreatePage}
        >
          Criar campanha
        </button>
      </div>
      <div className={CampaignsStyle['container']}>
        <div className={CampaignsStyle['list']}>
          <CardList
            className={CampaignsStyle['list-item']}
            onClick={clickEvent}
            items={data}
          />
        </div>
        <Paginate
          className={CampaignsStyle['paginate']}
          buttonClassName={CampaignsStyle['button']}
          displayClassName={CampaignsStyle['text']}
          page={page}
          perPage={perPage}
          onClick={fetchDataFromApi}
          totalItems={totalItems}
        />
      </div>
    </div>
  );
};

CampaignsContainer.defaultProps = {
  history: null,
  location: null,
  match: null,
  staticContext: null,
  token: null,
  person: null,
};

CampaignsContainer.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
  staticContext: PropTypes.func,
  token: PropTypes.string,
  person: PropTypes.object,
};

const mapStateToProps = state => ({
  token: state.token.data.Authorization,
  person: state.person.data,
});

const mapDispatchToProps = dispatch => ({
  isAdmin: (email, callback) => {
    dispatch(PartnerAdminActions.isAdmin(email, callback));
  },
});

const StatefulCampaigns = connect(
  mapStateToProps,
  mapDispatchToProps
)(CampaignsContainer);

export const Campaigns = withRouter(StatefulCampaigns);
